import { Type } from '@sinclair/typebox';
import { IsoDateTimeSchema, JsonObjectSchema, UuidSchema } from './common.js';
// JSON-serialized view of each Drizzle row. Dates serialize to ISO strings.
// Nullable columns become Type.Union([T, Type.Null()]).
export const TfTrackSchema = Type.Object({
    id: UuidSchema,
    name: Type.String(),
    displayName: Type.Union([Type.String(), Type.Null()]),
    description: Type.Union([Type.String(), Type.Null()]),
    openapiSpecJson: Type.Union([JsonObjectSchema, Type.Null()]),
    apiUrl: Type.String(),
    baseUrl: Type.Union([Type.String(), Type.Null()]),
    healthCheckUrl: Type.Union([Type.String(), Type.Null()]),
    systemPrompt: Type.Union([Type.String(), Type.Null()]),
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
});
export const TfChatSessionSchema = Type.Object({
    id: UuidSchema,
    userId: Type.String(),
    trackId: Type.Union([UuidSchema, Type.Null()]),
    title: Type.Union([Type.String(), Type.Null()]),
    metadata: Type.Union([JsonObjectSchema, Type.Null()]),
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
});
export const TfChatMessageSchema = Type.Object({
    id: UuidSchema,
    sessionId: UuidSchema,
    role: Type.String(),
    content: Type.Union([Type.String(), Type.Null()]),
    toolCalls: Type.Union([Type.Array(Type.Unknown()), Type.Null()]),
    toolResults: Type.Union([Type.Array(Type.Unknown()), Type.Null()]),
    tokenCount: Type.Union([Type.Integer(), Type.Null()]),
    createdAt: IsoDateTimeSchema,
    // Faithful render transcript, hydrated server-side into ready-to-render UI
    // parts (ordered text/tool/card parts; card pointers resolved from their
    // owning tables at current status). Absent on rows that predate the feature —
    // the client falls back to content + tool_results reconstruction.
    uiParts: Type.Optional(Type.Array(Type.Unknown())),
});
export const TfPromptSchema = Type.Object({
    id: UuidSchema,
    trackId: UuidSchema,
    name: Type.String(),
    description: Type.Union([Type.String(), Type.Null()]),
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
});
export const TfPromptVersionSchema = Type.Object({
    id: UuidSchema,
    promptId: UuidSchema,
    version: Type.Integer(),
    content: Type.String(),
    inputs: Type.Array(Type.String()),
    createdBy: Type.Union([Type.String(), Type.Null()]),
    createdAt: IsoDateTimeSchema,
});
export const TfApiKeySchema = Type.Object({
    id: UuidSchema,
    name: Type.String(),
    keyHash: Type.String(),
    keyPrefix: Type.String(),
    userId: Type.Union([UuidSchema, Type.Null()]),
    createdAt: IsoDateTimeSchema,
    revokedAt: Type.Union([IsoDateTimeSchema, Type.Null()]),
});
export const TfUserSchema = Type.Object({
    id: UuidSchema,
    email: Type.String({ format: 'email' }),
    emailVerifiedAt: Type.Union([IsoDateTimeSchema, Type.Null()]),
    name: Type.Union([Type.String(), Type.Null()]),
    avatarUrl: Type.Union([Type.String(), Type.Null()]),
    roles: Type.Array(Type.String()),
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
    disabledAt: Type.Union([IsoDateTimeSchema, Type.Null()]),
    /** True once a local password is set — an invited user is "active" then (HUB-106). */
    hasPassword: Type.Boolean(),
    /** Second-factor state (HUB-121 D7); filled by the admin `/users` routes. */
    mfa: Type.Optional(Type.Object({ enrolled: Type.Boolean() })),
});
//# sourceMappingURL=tables.js.map